import classnames from 'classnames'
import * as React from 'react'
import './styles.css'

interface Props {
  className?: string,
  center?: boolean,
  load?: () => void,
  size?: string,
  top?: number,
}

export const Sizes = {
  LARGE: '64',
  MEDIUM: '32',
  SMALL: '16',
}

export class Loading extends React.Component<Props> {
  public static Sizes = Sizes
  protected static defaultProps = {
    size: Sizes.MEDIUM,
    top: Sizes.MEDIUM,
  }
  public componentDidMount() {
    if (this.props.load) {this.props.load()}
  }
  public render() {
    return <span
        className={classnames(
          'k-icon',
          'k-i-loading',
          'loading',
          `size-${this.props.size}`,
          {'center-please': this.props.center},
          this.props.className,
        )}
        style={{fontSize: `${this.props.size}px`, top: `${this.props.top}`}}
        />
  }
}



// WEBPACK FOOTER //
// ./src/components/loading/component.tsx